export class SoapDraftApprovalLifecycle {
  private generation = 0;

  begin(): number {
    this.generation += 1;
    return this.generation;
  }

  invalidate(): void {
    this.generation += 1;
  }

  isCurrent(generation: number): boolean {
    return generation === this.generation;
  }

  async run<T>(work: () => Promise<T>): Promise<
    | { status: "fulfilled"; value: T }
    | { status: "rejected"; error: unknown }
    | { status: "superseded" }
  > {
    const generation = this.begin();
    try {
      const value = await work();
      return this.isCurrent(generation)
        ? { status: "fulfilled", value }
        : { status: "superseded" };
    } catch (error) {
      return this.isCurrent(generation)
        ? { status: "rejected", error }
        : { status: "superseded" };
    }
  }
}
